


































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

import Popup from '@/components/Popups/Popup.vue';

@Component({
    components: {
        Popup
    },
    model: {
        prop: "model",
        event: "visibilityChanged"
    }
})
export default class InfoPopup extends Vue {
    public visibility = false;
        
    // Properties
    @Prop({ required: false })
    public model?: boolean;

    @Prop({ required: false })
    public title?: string;

    // Getter & Setter
    public get visible(): boolean {
        return this.model ?? this.visibility;
    }
    public set visible(value: boolean) {
        this.visibility = value;
        this.$emit('visibilityChanged', value);
    }

    // Watcher

    // Lifecycle Methods:

    // Events:
    public opened(): void {
        this.$emit('opened');
    }
    public closed(): void {
        this.$emit('closed');
    }

    // Methods:
    public close(): void {
        this.visible = false;
    }
}
